import { isStudyStudentExperience } from '@/pages/try/studyExperience/mode';
import { resolveInstitutionShortCode } from '@/lib/institutionHost';

export const AIRBOTIX_CLIENT_HEADER = 'X-Airbotix-Client';

export type AirbotixClient = 'app' | 'institution';

/**
 * Select the session surface from the trusted institution-host parser.
 * Reserved, nested and lookalike hosts always remain on the normal app surface.
 */
export function resolveAirbotixClient(
  hostname: string,
  search = '',
  envShortCode?: string,
): AirbotixClient {
  return resolveInstitutionShortCode(hostname, search, envShortCode) ? 'institution' : 'app';
}

export function currentAirbotixClient(): AirbotixClient {
  if (typeof window === 'undefined') return 'app';
  if (
    isStudyStudentExperience() &&
    new URLSearchParams(window.location.search).get('experience') === 'live'
  )
    return 'app';
  return resolveAirbotixClient(window.location.hostname, window.location.search);
}

export function airbotixClientHeaders(): Record<string, string> {
  return { [AIRBOTIX_CLIENT_HEADER]: currentAirbotixClient() };
}
